import { DurationType, formatDuration } from "helpers/duration-formatter";

export const filters = {
    install: (Vue) => {
        Vue.filter("formatDuration", (value) => {
            if (typeof value !== "number") {
                return value;
            }

            if (value) {
                return formatDuration(value, DurationType.Millisecond);
            } else {
                return "n/a";
            }
        });
    }
};

export default filters;
